<template>
  <div class="info-home">
    <h6 class="ui header info-header">
      <i class="info icon"></i>
      <div class="content">
        To get a <strong>Patient Risk Model</strong> calculated, use the left
        sidebar to add the patient's demographic, clinical and molecular
        Information.
        <span class="how-to" @click.stop="$driver.start()">
          Learn here how to use it
        </span>
      </div>
    </h6>
  </div>
</template>

<script>
export default {
  name: "InfoHome"
};
</script>

<style lang="scss">
.info-home {
  .ui.header.info-header {
    color: #00113d;
    font-family: DM Sans;
    font-size: 18px;
    font-weight: 300;
    padding: 16px;
    // position: fixed;
    strong {
      font-style: italic;
    }
    span {
      cursor: pointer;
      font-weight: 700;
    }
  }
}
</style>
